module.exports = __webpack_public_path__ + "img/shop-add.3815468a.svg";